import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className={"footer__wrapper"}>
      <div className={"footer__copyright"}>© TriloDocs Ltd.</div>
      <div className={"footer__link"}>
        <Link to={"https://trilodocs.com/privacy-notice"} target="_blank">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default Footer;
